import {
  styled,
  Table,
  TableHead,
  TableCell,
  Box,
  Typography,
  Theme,
  Grid,
  Checkbox as MuiCheckbox,
  CheckboxProps,
  TableRow,
} from '@material-ui/core';

export const StyledTable = styled(Table)({
  tableLayout: 'fixed',
});

export const StyledTableHead = styled(TableHead)({
  backgroundColor: '#00000010',
});

export const StyledTableRow = styled(TableRow)({
  '&.rowLocked': {
    background: '#e6909044 !important',
    pointerEvents: 'none',
  },
});

export const StyledCell = styled(TableCell)({
  borderRight: 'none',
  textAlign: 'right',
  width: '1%',
  padding: '1.15rem',
  '&:nth-child(1)': {
    '> *': {
      width: '28px', // Force checkbox to break bounds to be fully rendered even at weird screen sizes
    },
    width: '1%',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },

  '&:nth-child(2)': {
    width: '6%',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },

  '&:nth-child(3)': {
    width: '2%',
  },

  '&:nth-child(4)': {
    width: ' 3%',
  },
  '&:nth-child(5)': {
    width: ' 2%',
  },
  '&:nth-child(6)': {
    width: '2%',
  },
  '.rowLocked': {
    background: '#e6909044 !important',
    pointerEvents: 'none',
  },
});

export const AdditionalFieldsBox = styled(Grid)({
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '0.5rem',
});

export const ProductName = styled(Typography)<Theme, { depthLevel: number }>(
  ({ depthLevel }) => {
    return {
      fontSize: '1.1rem',
      wordBreak: 'break-word',
      fontWeight: depthLevel === 1 ? 500 : 300,
    };
  },
);

export const ProductInfo = styled(Box)<Theme, { depthLevel: number }>(
  ({ depthLevel }) => {
    return {
      flexGrow: 1,
      paddingLeft: depthLevel ? `${depthLevel * 16}px` : '4px',
    };
  },
);

export const ProductQuantity = styled(Typography)({
  wordBreak: 'keep-all',
  whiteSpace: 'nowrap',
  textAlign: 'end',
  marginLeft: '8px',
  fontSize: '1.25rem',
  fontWeight: 300,
});

export const CardGroup = styled('div')({
  '& .MuiCard-root': {
    '&:not(:last-child)': {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottom: 'none',
    },
    '&:not(:first-child)': {
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
    },
    '& > .MuiCard-root': {
      borderRight: 'none',
      borderLeft: 'none',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },
});

export const RowCardContent = styled('div')({
  padding: '0.75rem 1rem',
  '&.rowLocked': {
    background: '#e6909044 !important',
    pointerEvents: 'none',
  },
});

export const Checkbox = styled(MuiCheckbox)<
  Theme,
  CheckboxProps & { invisible?: boolean }
>(({ invisible }) => ({
  padding: 0,
  visibility: invisible ? 'hidden' : 'visible',
}));
